import { X } from "lucide-react";

interface NotCoveredProps {
  subtitle: string;
  exclusions: string[];
}

export default function NotCovered({ subtitle, exclusions }: NotCoveredProps) {
  return (
    <section className="tw-w-full tw-bg-[#F7F7F8] tw-py-20 md:tw-py-0 md:tw-h-[489px] tw-flex tw-items-center">
      <div className="tw-w-full tw-max-w-[1120px] tw-mx-auto tw-px-6">
        {/* Heading */}
        <div className="tw-text-center tw-mb-11">
          <h2 className="tw-text-3xl md:tw-text-[40px] tw-font-semibold tw-text-[#111]">
            What the plan doesn’t cover
          </h2>

          <p className="tw-mt-4 tw-text-sm md:tw-text-base tw-text-gray-500">
            {subtitle}
          </p>
        </div>

        {/* Cards */}
        <div className="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 lg:tw-grid-cols-3 tw-gap-4 tw-items-start">
          {exclusions.map((item) => (
            <div
              key={item}
              className="tw-flex tw-items-center tw-gap-3 tw-bg-white tw-rounded-xl tw-px-5 tw-py-[18px]"
            >
              <X size={16} className="tw-shrink-0 tw-text-red-500" />
              <span className="tw-text-[15px] tw-leading-snug tw-text-[#111]">
                {item}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
